<template>
  <div class="mainbody" style="margin-top: -4rem;">
     
      <div class="modules0 modules00" style="text-align: center;"  v-scroll-animate="'slide-itemgk'">
            <div class="title-with-lines">
              <div class="clipped-gradient-line0510 clipped-gradient-line10510"></div>
              <span class="title-text"><span>公司简介</span></span>
              <div class="clipped-gradient-line0510"></div>
            </div>
           
      </div>

      <div class="whiteBg" > 
        <div class="txtMd2"  > 
          <div class="modern-ellipsis1" v-html="dataObj0.content" v-scroll-animate="'fly-in-left5'"></div>
        </div>
        <div class="imgMd2" v-scroll-animate="'fly-in-right5'"> 
          <!-- <img src="../../assets/img3/yewubankuai1/2.png" /> -->
          <!-- <img src="../../assets/ywbkNew/2/item6-1.png" /> -->
          <CarouselHomeyewubankuai class="showImg" ref="carusel0" :imgList="dataObj0.imgList" :heightParam="heightParam" />
        </div>
      </div>

      <div class="modules0 modules00" style="text-align: center;"  v-scroll-animate="'slide-itemgk'">
            <div class="title-with-lines">
              <div class="clipped-gradient-line0510 clipped-gradient-line10510"></div>
              <span class="title-text"><span>主营业务</span></span>
              <div class="clipped-gradient-line0510"></div>
            </div>
      </div>
      <div class="zhuyingyewu">
        <p v-html="dataObj1.content" v-scroll-animate="'fly-in-bottom'"></p> 
        <!-- <p> 
          公司聚焦房屋建筑工程、水利水电工程、内河航运工程建设主责主业，依托“一带一路”国家战略与河南“通江达海”航运规划，以专业技术与高效管理助力区域交通网络完善逐步形成“立足河南、辐射全国、服务丝路”战略布局。
        </p> -->
        <div class="felxImgDiv" v-scroll-animate="'fly-in-bottom'"> 
            <div v-for="item in dataObj1.imgList" :key="item.src"> 
              <img :src="item.src" />  
              <!-- <p>测试数据</p> -->
            </div>
           
            
        </div>
      </div>

      <div class="modules0 modules00" style="text-align: center;"  v-scroll-animate="'slide-itemgk'">
            <div class="title-with-lines">
              <div class="clipped-gradient-line0510 clipped-gradient-line10510"></div>
              <span class="title-text"><span>在建项目</span></span>
              <div class="clipped-gradient-line0510"></div>
            </div>
      </div>
      <div class="zaijianDiv"> 
        <div v-html="dataObj2.content" v-scroll-animate="'fly-in-bottom'"></div> 
      </div>
 
     

     
   </div>
</template>

<script>
// import Modules3 from '@/components/gk/Modules3.vue'
import CarouselHomeyewubankuai from '@/components/carousel_home/indexyewubankuai.vue'
import API from '@/api/index'


export default {
 components: {
  CarouselHomeyewubankuai
 },
 data() {
   return {
    urlBase: process.env.VUE_APP_BASE_API,
   indexNum:null,
   indexNum1:null,
   heightParam:'28vw',
   
   dataObj0:{},
   dataObj1:{},
   dataObj2:{},
    
   }
 },
 props: {
   
 },
 mounted() {
     this.zhongoubanlieData();
   },
 methods: {
    //获取页面数据
    async zhongoubanlieData() {
      try {
        let objParams={
          catId:'d9d3117b06684dc38a89cbdbbe2b4911'
        }
        const res = await API.getProcorementData(objParams)
        let arr0=res.data.constructionList['0'][0]
        let arr1=res.data.constructionList['1'][0]
        let arr2=res.data.constructionList['2'][0]
        let arr=[arr0,arr1,arr2]
         
        this.$nextTick(()=>{
          arr.forEach(item=>{
            if(item.type == '0'){
              this.dataObj0=item
            }else if(item.type == '1'){
              this.dataObj1=item
            }else if(item.type == '2'){
              this.dataObj2=item
            }
          })
         
          
        
          let imgarr0= this.dataObj0.photo.split('|').slice(1)
          let imgList0=[]
          imgarr0.forEach(item1=>{
            imgList0.push({
                      src: this.urlBase+item1,
                      line1: ' ',
                      line2: ' ',
            })
          })
          this.dataObj0['imgList']=imgList0

          let imgarr1= this.dataObj1.photo.split('|').slice(1)
          let imgList1=[]
          imgarr1.forEach(item1=>{
            imgList1.push({
                      src: this.urlBase+item1,
                      line1: ' ',
                      line2: ' ',
            })
          })
          this.dataObj1['imgList']=imgList1

          
        //   console.log('获取成功', res.data.resultData)
        })
       
      } catch (error) {
        console.error('获取失败', error)
      }
    },

    
 },
}
</script>

<style lang="scss" scoped>
::v-deep .img_item{
  padding-top: 0 !important;
}
 .mainbody{
   width: 100%;
   // background: #dde8f4;
   // margin-block: 100px;
   // background:url('../../assets/img3/gaikuang1/chanyepng.png');
 // background-size: 100% 100%;
 // .modules0{
 // 	width: 100%;
 // 	margin: 0 auto;
 // }
    
 }
 .containerDiv{
 width: 100%;
   // background: #dde8f4;
   // margin-block: 100px;
  //  background:url('../../assets/img3/gaikuang1/chanyepng.png');
//  background-size: 100% 100%;
 @media screen and (max-width: 768px) {
   background-size: auto 100%;
 }
 }

 .whiteBg{
   width: 90vw;
   margin:0 auto;
   overflow: hidden;
   height: 28vw;
  //  margin-bottom: 5rem;
  //  padding:2rem 0;
  //  background:url('../../assets/img3/yewubankuai1/2.png') no-repeat;
    // background-size: auto 100%;
    // background-position: right;
  //  background:linear-gradient(to bottom, rgba(252, 253, 253, 0), rgb(251, 252, 252,0.8))
  display: flex;
  @media screen and (max-width: 768px) {
    display: block;
    height:auto;
    }
  .txtMd2{
    flex: 50%;
    width: 50%;
    padding-left: 5%;
    padding:0 2rem;
    // padding-left:5vw;
    height: 28vw;
    // border: 1px solid red;
    font-size: 1.0rem;
    line-height: 2.0rem;
    text-indent:2rem !important;
    color: #ffffff;
    text-align: justify;
    display: grid;
    place-items: center; /* 水平 + 垂直居中 */
  
      background-color:#1868AB;  
    @media screen and (max-width: 768px) {
      width: 100%;
      // color:red;
      margin-left:0;
      line-height: 2rem;
      height:auto;
    }
    div{
      text-align: justify !important;
      // background: red;
    }
    p{
      font-size: 1.1rem;
    }
  }
  .txtMd2 ::v-deep(*) {
    font-size: 1.0rem;
  }
  .txtMd2 ::v-deep(p) {
     width: 100%;
     display: block;
     text-indent: 2rem !important;

    //  background: red;
  }
  .imgMd2{
    width: 50%;
    @media screen and (max-width: 768px) {
      width: 100%;
    }
   
    img{
      width: 100%;
      height: 28vw !important;
      object-fit: cover;
    }
  }
 } 
 .modules3Container{


  position: relative;
  width: 100%;
  .modules3Item{
 
  color: #333333;
 }

 }
 .modules3Container1{
  // width: 100%;
  // background:url('../../assets/ywbkNew/1/7.png');
  // background-size: cover;
  // min-height: 50vw;
  margin-top: 2rem;
  position: relative;
  width: 100%;
  padding-bottom: 26.25%; /* 16:9 比例 (9/16=0.5625) */
  background:url('../../assets/img3/yewubankuai1/3.png');
  background-size: cover;
  background-position: center;

 }
 .modules3Div{
   width: 90vw;
   margin:0 auto;
   padding:2rem 0;
 }
 .modules3Item{
  background: none;
  border: 1px solid #a3c9fa;
  color: #ffffff;
  padding: 4rem 0;
 }
 .modules3rowDiv{
  // padding-top:3rem;
 }
 .activeYwbkItem2{
  // background-color: rgba(249, 249, 251, 0.5);  
  background: #015293;

  
   .titleModule3item{
    font-size: 1.2rem;
    font-weight: bold;
    color: #ffffff;
   }
   li{
   img{
    filter: brightness(0) invert(1); /* 将图片变为白色 */
   }
   }
 }
 .modules3Div1{
  width: 65%;
  padding-left: 5%;
  color: #ffffff;
  // background: #ffffff;
  h5{
    font-size: 1.2rem;
    padding:2rem 0;
  }
  p{
    font-size: 1rem;
    line-height: 2rem;
  }
 }
 .goDetailDiv{
  text-align: center;
  a{
    color: #015293;

  }
}

.modules00 {
    padding:2rem 0;
}
 .modules00 *{
  color: #015293 !important;
  .title-text{
    padding: 0 10px;
    font-size: 1.2rem;
    color: #ffffff;
    white-space: nowrap;
    span{
      font-size: 1.4rem;
    }
  }
 



.clipped-gradient-line0510 {
    display: inline-block;
    width: 10vw;
    height: 0.2rem;
    transform: translateY(-0.5rem);
    background: linear-gradient(to right,
            #015293,
            #337ab4,
            #cbdfee,
            #fafafb00);
}

@media screen and (max-width: 768px) {
    .clipped-gradient-line0510  {
        width: 2vw; 
        // 右侧
    }
    
}

.clipped-gradient-line10510 {
    transform: translateY(-0.5rem);
    display: inline-block;
    width: 10vw;
    height: 0.2rem;
    background: linear-gradient(to right,
            #fafafb00,
            #cbdfee,
            #337ab4,
            #015293);
}

 }
 .zhuyingyewu{
  width: 90vw;
  margin:0 auto !important;
  text-indent: 2rem !important;
  line-height: 2rem;
 }
 .felxImgDiv{
    width:90vw;
    margin-top: 1rem;
    display: flex;
    gap:1rem;
    div{
      flex: 1;
      // background: green;
      overflow: hidden;
      text-align: center;
      padding:0 !important;
      img{
        width: 100% !important;
        display: block;
      }
      p{
       padding-top: 1rem;
      }
    }
 }
 .zaijianDiv{
  width: 90vw;
  margin:0 auto;
  
 }
  ::v-deep p{
line-height: 2rem !important;
     }


.modern-ellipsis1 {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 12;

    /* 台式机 (可能更大或比例不同) */
    @media screen and (min-width: 1920px),
    screen and (min-width: 1600px) and (min-aspect-ratio: 16/10) {
        -webkit-line-clamp: 12;
    }
      @media only screen and (max-width: 767px)
        {
           -webkit-line-clamp: 30;
        }

    overflow: hidden;
    text-overflow: ellipsis;

    /* 处理内部元素 */
    >* {
        display: inline;
        /* 强制内联显示 */
        white-space: normal;
    }
}
 ::v-deep{
       @media only screen and (max-width: 767px)
        {
          .showImg{
            .el-carousel__item{
             img{
              width: 100% !important;
             }
              
            }
          }
        }
   }
 </style>